// extracted by mini-css-extract-plugin
export default {"stat":"Github_stat__Thi5H","one":"Github_one__3Zr8O","two":"Github_two__lSv0a","three":"Github_three__qhfYH","github":"Github_github__+ksdl"};